import { defineMessages } from "react-intl";
import { renderChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "react";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { withDataGridEntityClient, withDataGridEntityServer } from "../../../components/data-grid/mui/DataGridEntity.js";
import { MuiDataGridClient } from "../../../components/data-grid/mui/MuiDataGridClient.js";
import { MuiDataGridServer } from "../../../components/data-grid/mui/MuiDataGridServer.js";
import { DataGridEntityConfigFactory } from "../../../components/data-grid/mui/types.js";
import "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import { renderCellWithTooltip } from "../../../components/data-grid/mui/cells/GridCellWithTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import { renderCellHeader } from "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import { renderDefaultChipCell } from "../../../components/data-grid/mui/cells/ChipCell.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import { renderPercentCell } from "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import { formatTimestamp } from "../../../utils/date.js";
import { RevenueShareOfferingStatusTypeName } from "../constants.js";
const localizedHeaders = defineMessages({
  referee: {
    id: "DataGridPlayerReferral_referee",
    defaultMessage: "Referred Players"
  },
  referrerId: {
    id: "DataGridPlayerReferral_referrerId",
    defaultMessage: "Referrer Of Player"
  },
  revenueShare: {
    id: "DataGridPlayerReferral_revenueShare",
    defaultMessage: "Revenue Share"
  },
  revenueGeneratedTotal: {
    id: "DataGridPlayerReferral_revenueGeneratedTotal",
    defaultMessage: "Total Accumulated Revenue Share"
  },
  revenueShareOfferingStatus: {
    id: "DataGridPlayerReferral_revenueShareOfferingStatus",
    defaultMessage: "Revenue Share Offering Status"
  },
  expirationDate: {
    id: "DataGridPlayerReferral_expirationDate",
    defaultMessage: "Expiration Date"
  }
});
class DataGridPlayerReferralConfigFactory extends DataGridEntityConfigFactory {
  getColumnConfig() {
    const columnsMapping = {
      referrer_id: {
        field: "referrer_id",
        valueGetter: (_, row) => this.getReferrerId(row),
        renderHeader: () => renderCellHeader(localizedHeaders.referrerId),
        renderCell: renderDefaultChipCell,
        sortable: false,
        flex: 0.12
      },
      "referee.uid": {
        field: "referee.uid",
        valueGetter: (_, row) => this.getRefereeUid(row),
        renderHeader: () => renderCellHeader(localizedHeaders.referee),
        renderCell: renderDefaultChipCell,
        sortable: false,
        flex: 0.1
      },
      revenue_generated_total: {
        field: "revenue_generated_total",
        valueGetter: (_, row) => this.getRevenueGeneratedTotal(row),
        renderHeader: () => renderCellHeader(localizedHeaders.revenueGeneratedTotal),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.15
      },
      revenue_share_offering_status: {
        field: "revenue_share_offering_status",
        valueGetter: (_, row) => this.getRevenueShareOfferingStatus(row),
        renderHeader: () => renderCellHeader(localizedHeaders.revenueShareOfferingStatus),
        renderCell: (params) => renderChip(params.value, RevenueShareOfferingStatusTypeName),
        sortable: false,
        flex: 0.15
      },
      revenue_share: {
        field: "revenue_share",
        valueGetter: (_, row) => this.getPescentCellRevenueShare(row),
        renderHeader: () => renderCellHeader(localizedHeaders.revenueShare),
        renderCell: renderPercentCell,
        sortable: false,
        flex: 0.2
      },
      expiration_date: {
        field: "expiration_date",
        valueGetter: (_, row) => this.getExpirationDateFormattedValue(row),
        renderHeader: () => renderCellHeader(localizedHeaders.expirationDate),
        renderCell: renderCellWithTooltip,
        sortable: false,
        flex: 0.25
      }
    };
    return columnsMapping;
  }
  getPescentCellRevenueShare(model) {
    return { value: model?.revenue_share };
  }
  getExpirationDateFormattedValue(model) {
    return formatTimestamp(model?.expiration_date, "date");
  }
  getReferrerId(model) {
    return model?.referrer_id;
  }
  getRefereeUid(model) {
    return model?.referee?.uid;
  }
  getRevenueGeneratedTotal(model) {
    return model?.revenue_generated_total;
  }
  getRevenueShareOfferingStatus(model) {
    return model?.revenue_share_offering_status;
  }
}
const DataGridPlayerReferralsClient = withDataGridEntityClient(
  MuiDataGridClient,
  () => new DataGridPlayerReferralConfigFactory().getColumnConfig()
);
const DataGridPlayerReferralsServer = withDataGridEntityServer(
  MuiDataGridServer,
  () => new DataGridPlayerReferralConfigFactory().getColumnConfig()
);
export {
  DataGridPlayerReferralConfigFactory,
  DataGridPlayerReferralsClient,
  DataGridPlayerReferralsServer,
  localizedHeaders
};
//# sourceMappingURL=DataGrid.js.map
